<div class="contains-button">
   <!-- Hiển thị tiêu đề mở rộng -->
   <div class="editor-header" *ngIf="isViewAll">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
   </div>

   <ng-container *ngIf="!isViewAll">
      <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
      </app-position-out-config>

      <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="width" [height]="height" (changeWidthHeight)="changeWidthHeight($event)">
      </app-width-height-config>

      <ul nz-menu nzMode="inline">
         <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
            <div class="button-size">
               <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
               </app-hide-show-config>
            </div>
         </li>

         <li nz-submenu nzTitle="{{'kieu_hien_thi' | translate}}" [(nzOpen)]="openMap.menu8"
            (nzOpenChange)="openHandler('menu8')">
            <nz-select [(ngModel)]="config['type_display']" (ngModelChange)="updateConfig()">
               <nz-option [nzValue]="'resize'" nzLabel="{{'dan' | translate}}"></nz-option>
               <nz-option [nzValue]="'scroll'" nzLabel="{{'cuon' | translate}}"></nz-option>
            </nz-select>
         </li>

         <li nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
            <div class="color-pick mb-4">
               <span class="title w-50">{{'mau_nen' | translate}}</span>
               <input
                  class="input-color w-50"
                  type="button"
                  [cpOKButton]="true"
                  [(colorPicker)]="class['booking-hotel-manage']['background-color']"
                  [style.background]="class['booking-hotel-manage']['background-color']"
                  (colorPickerClose)="updateClass()"
                  [cpWidth]="'230px'"
                  [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true"
                  [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate"
                  [disabled]="config['background-color'].gradient_check"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors"
                  (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                  (colorPickerOpen)="themeService.onPickerColorOpen($event)"
               />
            </div>
            <div class="mr-2 mb-4 mt-4 view-more" style="display: flex; align-items: center; justify-content: flex-end; gap: 7px;">
               <p class="discover_text" (click)="openViewAll(styles_field[3])" style="cursor: pointer; text-align: left; margin: 0">
                  {{'mau_gradient' | translate}} &#8594;
               </p>
            </div>
         </li>

         <li
            nz-submenu
            nzTitle="{{ 'mau_sac' | translate }}"
            [(nzOpen)]="openMap.menu6"
            (nzOpenChange)="openHandler('menu6')">

            <div class="color-group" *ngFor="let group of manageColorSections" style="margin-bottom: 12px;">
               <div class="color-group__header"
                  style="display: flex; align-items: center; justify-content: space-between; cursor: pointer; padding: 6px 0; border-bottom: 1px solid #e7ebf1;"
                  (click)="toggleColorGroup(group.title)">
                  <span class="title" style="font-weight: 600; font-size: 13px;">
                     {{ group.title | translate }}
                  </span>
                  <i class="bi" [ngClass]="isColorGroupOpen(group.title) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
               </div>

               <div class="color-group__body" *ngIf="isColorGroupOpen(group.title)" style="padding-top: 8px;">
                  <div class="color-pick mb-4" *ngFor="let item of group.fields">
                     <span class="title w-50">
                        {{ item.label | translate }}
                     </span>
                     <input
                        class="input-color w-50"
                        type="button"
                        [cpOKButton]="true"
                        [(colorPicker)]="manageTheme[item.key]"
                        [style.background]="manageTheme[item.key]"
                        (colorPickerClose)="updateManageGroupColor(item.key)"
                        [cpWidth]="'230px'"
                        [cpPresetColors]="themeService.themeColors"
                        [cpAddColorButton]="true"
                        [cpAddColorButtonText]="'them_mau' | translate"
                        [cpPresetLabel]="'bang_mau_mau' | translate"
                        [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                        (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                        (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                     />
                  </div>
               </div>
            </div>
         </li>

         <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['booking-hotel-manage']" [id_object]="objectChoosing._id">
            </app-borders-config>

            <div class="item-border my-3" style="float: right">
               <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
                  {{'mo_rong' | translate}} &#8594;
               </p>
            </div>
         </li>

         <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['booking-hotel-manage']" [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
            </app-shadow-config>
         </li>

         <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
               [classPadding]="class['booking-hotel-manage']" [paddingConfigs]="[
               { type: 'top' },
               { type: 'bottom' },
               { type: 'left' },
               { type: 'right' }
            ]">
            </app-padding-config>
         </li>

         <li nz-submenu nzTitle="{{ 'noi_dung' | translate }}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
            <div class="color-group" *ngFor="let section of bookingContentSections" style="margin-bottom: 12px;">
               <div class="color-group__header"
                  style="display: flex; align-items: center; justify-content: space-between; cursor: pointer; padding: 6px 0; border-bottom: 1px solid #e7ebf1;"
                  (click)="toggleContentGroup(section.title)">
                  <span class="title" style="font-weight: 600; font-size: 13px;">
                     {{ section.title | translate }}
                  </span>
                  <i class="bi" [ngClass]="isContentGroupOpen(section.title) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
               </div>

               <div class="color-group__body" *ngIf="isContentGroupOpen(section.title)" style="padding-top: 8px;">
                  <mat-form-field style="width: 100%" *ngFor="let field of section.fields">
                     <mat-label>{{ field.label | translate }}</mat-label>
                     <textarea matInput [ngModel]="staticdata[field.key + '_' + functionService.selectedLanguageCode] | vhLanguage : field.key : objectChoosing.component" (ngModelChange)="staticdata[field.key + '_' + functionService.selectedLanguageCode] = $event" (blur)="updateStaticData()"></textarea>
                  </mat-form-field>
               </div>
            </div>
         </li>
      </ul>
   </ng-container>

   <!-- Xem chi tiết cấu hình object -->
   <div class="view-more" *ngIf="isViewAll">
      <!-- Cấu hình chi tiết viền -->
      <div class="view_more-border" *ngIf="currentViewAll.index == 2">
         <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['booking-hotel-manage']" [id_object]="objectChoosing._id">
         </app-borders-radius-config>
      </div>

      <!-- Cấu hình chi tiết hiệu ứng -->
      <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
         <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
      </div>

     <!-- Cấu hình chi tiết màu gradient  -->
      <div class="container-gradient" *ngIf="currentViewAll.index == 4">
         <div class="title-head">
            <p class="text-fill">{{'phoi_mau' | translate}}</p>
            <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check" (ngModelChange)="updateBackgroundRgb()"></label>
         </div>
         <div class="list-gradient">
            <button class="btn-gradient" *ngFor="
               let bgGradient of config['background-color']['gradient_arr'];
               let i = index
            " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="!config['background-color'].gradient_check">
            <i class="delete-icon bi bi-x-circle"></i>
            </button>
         </div>
         <p class="title-head">{{'them_mau' | translate}}</p>
         <div class="container_add-gradient">
            <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color'].background" type="button" [disabled]="!config['background-color'].gradient_check" [style.background]="config['background-color'].background" (colorPickerClose)="addGradient($event)" />
         </div>
         <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
         <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check" [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'" [class.active]="config['background-color'].gradient_direction === type.direction">
         </button>
      </div>
   </div>
</div>
